import styled from 'styled-components';

import { gridSizes, media, weights } from 'utils/style';
import PaymentMethodSelector from 'components/PaymentData/PaymentMethodSelector/container';

export default styled(PaymentMethodSelector)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: visible;
  margin-top: 32px;

  ${media.lessThan('medium')`
    overflow-y: auto;
  `};

  h1 {
    color: var(--grey900);
    font-size: 32px;
    margin: 0;
    font-weight: ${weights('medium')};
    line-height: 38px;
    margin-bottom: ${gridSizes('M')};
  }

  h2 {
    color: var(--grey900);
    font-size: ${gridSizes('M')};
    margin: 0;
    font-weight: ${weights('medium')};
    line-height: 19px;
  }

  p {
    color: var(--grey700);
    font-size: ${gridSizes('M')};
    margin: 0px;
  }

  label {
    padding: ${gridSizes('M')};
    height: auto;
    div {
      align-items: inherit;

      span:last-of-type {
        flex: 1;
      }
    }
  }

  .form-row {
    margin-top: ${gridSizes('S')};
    display: flex;

    label {
      padding: 1.2rem 1.2rem;
    }

    div {
      margin-right: ${gridSizes('M')};
      &:last-of-type {
        margin-right: 0px;
      }
    }
  }

  .inspectlet-sensitive {
    background: none;
  }
  .StripeElement {
    background: #fff;
  }

  .SEPA-checkbox {
    label > div {
      display: flex;
      justify-content: center;
      align-items: initial;
    }

    .error {
      margin-bottom: 0px;
    }
  }

  .stripe-icon {
    position: absolute;
    right: 10px;
    top: ${gridSizes('L')};

    svg {
      fill: var(--grey700);
      &:last-of-type {
        width: 120px;
      }
    }
  }

  .vat-value {
    font-size: ${gridSizes('M')};
    color: var(--grey900);
    font-weight: ${weights('regular')};
    margin: 0;
    text-align: right;

    .price {
      text-align: left;
      font-weight: ${weights('medium')};
      color: var(--grey900);
      font-size: 3.2rem;
    }

    ${media.lessThan('medium')`
      text-align: left;
    `};
  }
`;
